import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppMenu from "./AppMenu";
import { classNames } from "primereact/utils";
import { Avatar } from "primereact/avatar";
import { getAllDetails } from "../service/ProductService";
import { GET_PROFILE_DATA_BY_ID } from "../config/ApiConstant";
// import { GET_PROFILE_DATA_BY_ID } from "../config/apiUrl";

const AppTopbar = (props: any) => {
  const navigate = useNavigate();

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const [profileData, setProfileData] = useState<any>(null);

  const getProfileData = async () => {
    try {
      const response = await getAllDetails(`${GET_PROFILE_DATA_BY_ID}/${userData?.id}`);
      if (response) {
        setProfileData(response);
      }
    } catch (error: any) {
      console.error("Error fetching profile data for topbar:", error);
    }
  };

  useEffect(() => {
    if (userData?.id) {
      getProfileData();
    }
  }, []);

  // logout functionality
  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // function to make first letter capital
  const capitalizeFirstLetter = (str: any) => {
    if (typeof str !== "string" || str.length === 0) {
      return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const userName = userData?.first_name ?? userData?.company_name ?? "";

  const firstName = capitalizeFirstLetter(userData?.first_name ?? "");
  const lastName = capitalizeFirstLetter(userData?.last_name ?? "");
  const companyName = capitalizeFirstLetter(userData?.company_name ?? "");

  // navigate based on userole
  const redirectProfileByRole = (role: string) => {
    switch (role) {
      case "Admin":
        return "/admin-profile";
      case "User":
        return "/user-profile";
      case "Client":
        return "/client-profile";
      case "Employee":
        return "/employee-profile";
      default:
        return "/profile";
    }
  };

  return (
    <>
      <div className="layout-topbar">
        <div className="flex gap-2 md:gap-3 lg:gap-0 layout-topbar-left align-items-center ">
          <div className="topbar-start">
            <button
              className="ml-0 topbar-menu-button p-link"
              onClick={props.onMenuButtonClick}
            >
              <i className="pi pi-bars"></i>
            </button>
          </div>
          <h3 className="mt-0 mb-0 product-name">Nexawage</h3>
        </div>

        <div className="flex layout-topbar-right align-items-center">
          <ul className="layout-topbar-right-items">
            <li
              id="profile"
              className={classNames("profile-item", {
                "active-topmenuitem": props.topbarMenuActive,
              })}
            >
              <span
                className="mr-1 text-white profile-name"
                onClick={props.onTopbarItemClick}
              >
                {firstName} {lastName} {companyName}
              </span>

              <button
                className="mr-0 p-link justify-content-center"
                onClick={props.onTopbarItemClick}
              >
                {profileData?.company_logo ? (
                  <img
                    src={profileData.company_logo}
                    alt="Company Logo"
                    style={{ width: "35px", height: "35px", borderRadius: "50%", objectFit: "contain", border: "1px solid #dee2e6" }}
                  />
                ) : !window.cn(userName) ? (
                  <Avatar
                    label={userName.charAt(0).toUpperCase()}
                    style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
                    shape="circle"
                  />
                ) : (
                  <Avatar
                    icon="pi pi-user"
                    style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
                    shape="circle"
                  />
                )}
              </button>

              <ul className="fadeInDown">
                <li role="menuitem">
                  <button
                    className="w-full p-link"
                    // onClick={() => navigate("/profile")}
                    onClick={() => {
                      const role = userData?.roles?.role_name;
                      navigate(redirectProfileByRole(role));
                    }}
                  >
                    <i className="pi pi-user pi-fw"></i>
                    <span style={{ fontWeight: "500" }}>Profile</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button
                    className="w-full p-link"
                    onClick={() => navigate("/change-password")}
                  >
                    <i className="pi pi-user pi-fw"></i>
                    <span style={{ fontWeight: "500" }}>Change Password</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="w-full p-link" onClick={logout}>
                    <i className="pi pi-fw pi-sign-out"></i>
                    <span style={{ fontWeight: "500" }}>Logout</span>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AppTopbar;
